import React, { useState, useEffect } from 'react';
import './ScrollToTopButton.css'; // Make sure to create this CSS file

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 100);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    isVisible && (
      <button className="scroll-to-top color" onClick={scrollToTop} title="Scroll to top">
        <i class="bi bi-arrow-up"></i>
      </button>
    )
  );
};

export default ScrollToTopButton;
